// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"17627":"66bb333ab84e501c","19351":"c1f7de0082641d15","53348":"d7a90387b46ebdcc","80828":"06117c9fc956fe6c","97555":"d25f44bab63504d0"}[chunkId] + ".js";
};